import React from "react";
import { getTabId } from "../../utils/getTabId";
import { useTabContext } from "./tabs.context";
/**
 * Tab Content component acts as a wrapper that shows/hides content
 * depending on whether the tab is selected
 */
export const TabPanel = ({ children, name, }) => {
    const { selectedTab } = useTabContext();
    const tabId = getTabId(name);
    if (selectedTab === tabId) {
        return (React.createElement("div", { id: `tabcontent-${tabId}`, role: "tabpanel" }, children));
    }
    return null;
};
